import { navigation } from '../../data/navigation'
import { socialMedia } from '../../data/socialMedia'
import { MessageCircle, Mail, Globe } from 'lucide-react'
import { trackNavigation, trackExternalLink } from '../../lib/firebase'

export function Footer() {
    const currentYear = new Date().getFullYear()

    // Filtra apenas as redes sociais habilitadas
    const enabledSocialMedia = socialMedia.filter(sm => sm.enabled)

    return (
        <footer className="bg-dpxp-dark text-white">
            <div className="container-section py-12">
                <div className="grid md:grid-cols-3 gap-8">
                    {/* Brand */}
                    <div>
                        <img
                            src="/assets/logo-dpxp-it-solutions-colorido.svg"
                            alt="DPXP IT Solutions"
                            className="h-16 w-auto mb-4 brightness-0 invert -ml-4"
                        />
                        <p className="text-gray-400 text-sm mb-4">
                            Clareza na TI, Vantagem no Negócio.
                            <br />
                            Governança, Dados e Arquitetura Corporativa.
                        </p>

                        {/* Social Icons - Renderização dinâmica */}
                        {enabledSocialMedia.length > 0 && (
                            <div className="flex gap-4">
                                {enabledSocialMedia.map((social) => {
                                    const Icon = social.icon
                                    return (
                                        <a
                                            key={social.id}
                                            href={social.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-10 h-10 rounded-full bg-white/10 hover:bg-dpxp-primary transition-colors flex items-center justify-center"
                                            aria-label={social.name}
                                        >
                                            <Icon className="w-5 h-5" />
                                        </a>
                                    )
                                })}
                            </div>
                        )}
                    </div>

                    {/* Navigation */}
                    <div>
                        <h4 className="font-semibold mb-4">Navegação</h4>
                        <nav className="flex flex-col gap-2">
                            {navigation.map((item) => (
                                <a
                                    key={item.href}
                                    href={`/${item.href}`}
                                    className="text-gray-400 hover:text-white transition-colors text-sm"
                                    onClick={() => trackNavigation(item.href, 'footer')}
                                >
                                    {item.label}
                                </a>
                            ))}
                        </nav>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-semibold mb-4">Contato</h4>
                        <div className="space-y-2 text-gray-400 text-sm">
                            <p className="flex items-center gap-2">
                                <MessageCircle className="w-4 h-4" />
                                <a
                                    href="https://wa.me/5521991937869"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                    onClick={() => trackExternalLink('whatsapp', 'wa.me', 'footer')}
                                >
                                    +55 21 98189-9344
                                </a>
                            </p>
                            <p className="flex items-center gap-2">
                                <Mail className="w-4 h-4" />
                                <a href="mailto:contato@dpxp.io" className="hover:text-white transition-colors" onClick={() => trackExternalLink('email', 'contato', 'footer')}>
                                    contato@dpxp.io
                                </a>
                            </p>
                            <p className="flex items-center gap-2">
                                <Globe className="w-4 h-4" />
                                <a
                                    href="https://dpxp.io"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                >
                                    dpxp.io
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-white/10 mt-8 pt-8 text-center text-gray-500 text-sm">
                    <p>
                        ©{currentYear} DPXP IT Solutions | {' '}
                        <a href="/politica-privacidade" className="hover:text-white transition-colors">
                            Política de Privacidade
                        </a>
                        {' '} | Todos os direitos reservados.
                    </p>
                </div>
            </div>
        </footer>
    )
}
